/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const defaultTranslations: Record<string, string> = {
  COMMON__BUTTON_VOLUME: "Volume",
  LOGIN_REQUIRED_ACTION: "Log in",
  LOGIN_REQUIRED_MESSAGE: "You need to log in to watch this content.",
  PLAYER_ARIA_VIDEO: "Video",
  PLAYER_ARIA_VIDEO_PLAYER: "Video player",
  PLAYER_AUTO_QUALITY_TRACK: "Auto",
  PLAYER_BUTTON_CONTINUE_WATCHING_FROM_START: "Start from beginning",
  PLAYER_BUTTON_CONTINUE_WATCHING_RESUME: "Resume",
  PLAYER_BUTTON_ERROR_CLOSE_PLAYER: "Close player",
  PLAYER_BUTTON_ERROR_RETRY: "Retry",
  PLAYER_BUTTON_NEXT_EPISODE: "Next episode",
  PLAYER_BUTTON_SKIP_AD: "Skip ad",
  PLAYER_CONTINUE_WATCHING_HEADER: "Continue watching?",
  PLAYER_DEFAULT_PLAYBACK_RATE: "Normal",
  PLAYER_DISABLED_SUBTITLES_TRACK: "Off",
  PLAYER_ERROR_CODE: "Error code",
  PLAYER_LIVE_ENDED_DESCRIPTION: "Thank you for watching",
  PLAYER_LIVE_ENDED_HEADER: "Live stream ended",
  PLAYER_LIVE_ENDED_INVITATION: "Join us for upcoming events",
  PLAYER_LIVE_STARTING_DESCRIPTION: "Get ready for the event",
  PLAYER_LIVE_STARTING_HEADER: "Live stream starts soon",
  PLAYER_MULTIPLE_ADS_INDICATOR: "Ads",
  PLAYER_PLAYLIST_BUTTON_TITLE: "Playlist",
  PLAYER_SETTINGS_AUDIO: "Audio",
  PLAYER_SETTINGS_PLAYBACK_RATE: "Playback speed",
  PLAYER_SETTINGS_QUALITY: "Quality",
  PLAYER_SETTINGS_SUBTITLES: "Subtitles",
  PLAYER_SINGLE_AD_INDICATOR: "Ad",
  PLAYER_TOOLTIP_AD: "Ad",
  PLAYER_TOOLTIP_AIRPLAY: "AirPlay",
  PLAYER_TOOLTIP_CHROMECAST_CONNECT: "Cast",
  PLAYER_TOOLTIP_CHROMECAST_CONNECTED_TO: "Connected to",
  PLAYER_TOOLTIP_CHROMECAST_DISCONNECT: "Disconnect",
  PLAYER_TOOLTIP_CLOSE_PLAYER: "Close player",
  PLAYER_TOOLTIP_CURRENTLY_LIVE: "Currently live",
  PLAYER_TOOLTIP_ENTER_FULLSCREEN: "Full screen",
  PLAYER_TOOLTIP_GO_TO_LIVE: "Go live",
  PLAYER_TOOLTIP_LEAVE_FULLSCREEN: "Close full screen",
  PLAYER_TOOLTIP_MUTE: "Mute",
  PLAYER_TOOLTIP_NEXT_EPISODE: "Next episode",
  PLAYER_TOOLTIP_PAUSE: "Pause",
  PLAYER_TOOLTIP_PLAY: "Play",
  PLAYER_TOOLTIP_SEEK_BACK: "Seek back",
  PLAYER_TOOLTIP_SEEK_FORWARD: "Seek forward",
  PLAYER_TOOLTIP_SETTINGS: "Settings",
  PLAYER_TOOLTIP_UNMUTE: "Unmute",
  SEASONS: "Seasons",
  WATCH__CONTINUE_WATCHING: "Continue watching",
  WATCH__START_FROM_BEGINNING: "Start from beginning",
};
